import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import AuthLayout from './auth/AuthLayout';
import { Banner, Field } from '../design/ui';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [result, setResult] = useState(null); // { tone, text }
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await axios.post('/api/auth/password-reset-request', { email });
      setResult({
        tone: 'success',
        text: response.data.message || t('publicUi.resetSent', 'Si un compte existe pour cette adresse, un lien de réinitialisation vient d’être envoyé.'),
      });
    } catch (error) {
      setResult({
        tone: 'danger',
        text: error.response && error.response.status === 400
          ? t('publicUi.requestFailedDetail', 'La demande a échoué : {{detail}}', { detail: error.response.data.detail })
          : t('publicUi.requestFailed', 'La demande a échoué. Réessayez dans un instant.'),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout
      heading={t('publicUi.forgotTitle', 'Mot de passe oublié')}
      subheading={t('publicUi.forgotSub', 'Saisissez l’e-mail du compte : vous recevrez un lien pour choisir un nouveau mot de passe.')}
      footer={<a className="u-link" href="/"><ArrowLeft size={14} aria-hidden="true" /> {t('publicUi.backToSignIn', 'Retour à la connexion')}</a>}
    >
      <form className="u-form" onSubmit={handleForgotPassword}>
        {result && <Banner tone={result.tone}>{result.text}</Banner>}
        <Field label={t('email', 'E-mail')} htmlFor="forgot-email">
          <input
            id="forgot-email"
            type="email"
            className="u-input"
            placeholder={t('enterEmail', 'Saisissez votre e-mail')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </Field>
        <button type="submit" className="u-btn u-btn--primary u-btn--block" disabled={isSubmitting}>
          {isSubmitting ? t('common.loading', 'Chargement…') : t('publicUi.sendLink', 'Envoyer le lien')}
        </button>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;
